export const Label = ({ label }) => {
  if (!label) return null;
  return <div style={{ fontSize: 14, fontWeight: 'bold', color: '#555', margin: '5px 0' }}>{label}</div>;
};
